import { render, staticRenderFns } from "./DesacumuladoComplementos.vue?vue&type=template&id=1ec4a00b&scoped=true"
import script from "./DesacumuladoComplementos.vue?vue&type=script&lang=js"
export * from "./DesacumuladoComplementos.vue?vue&type=script&lang=js"
import style0 from "./DesacumuladoComplementos.vue?vue&type=style&index=0&id=1ec4a00b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4a00b",
  null
  
)

export default component.exports